// import React, { useState, useMemo } from "react";
// import "../../styles/courses.css";
// import { Link } from "react-router-dom";
// import { courses } from "../../data/courses";
import React, { useState, useMemo, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../styles/courses.css";
import { courses } from "../../data/courses";
import { Helmet } from "react-helmet-async";


export default function CoursesPage() {
  // const [topicFilter, setTopicFilter] = useState("");
  // const [levelFilter, setLevelFilter] = useState("");


  const location = useLocation();

  const scrollToTopInstant = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto", // or "smooth" if you like
    });
  };

  // read ?category= from the URL, e.g. /courses?category=School
  const params = new URLSearchParams(location.search);
  const urlCategory = params.get("category") || "";

  const [topicFilter, setTopicFilter] = useState("");
  const [levelFilter, setLevelFilter] = useState(urlCategory);

  // keep levelFilter in sync if URL query changes while on the page
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const categoryFromUrl = params.get("category") || "";
  setLevelFilter(categoryFromUrl);

  // 👇 force scroll to top when category changes via footer links
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // or "auto" if you don't want animation
  });
}, [location.search]);




  // Normalize data for filtering & display
  const normalizedCourses = useMemo(
    () =>
      courses.map((c) => {
        const difficulty = c.target || c.level || "";
        const topic = c.frequency || c.tag || "";
        const shortDescription = c.shortDescriptionCover || c.desc || "";
        const duration = c.durationHours || "";
        const audience = c.targetAudience || c.audience || "";

        return {
          ...c,
          _difficulty: difficulty,
          _topic: topic,
          _shortDescription: shortDescription,
          _duration: duration,
          _audience: audience,
        };
      }),
    []
  );

  // Filtered list
  const filteredCourses = useMemo(() => {
    return normalizedCourses.filter((c) => {
      const matchTopic = topicFilter ? c._topic === topicFilter : true;
      const matchLevel = levelFilter ? c._difficulty === levelFilter : true;
      return matchTopic && matchLevel;
    });
  }, [normalizedCourses, topicFilter, levelFilter]);

  // Unique topics & levels for dropdowns
  const uniqueTopics = [
    ...new Set(normalizedCourses.map((c) => c._topic).filter(Boolean)),
  ];
  const uniqueLevels = [
    ...new Set(normalizedCourses.map((c) => c._difficulty).filter(Boolean)),
  ];

  return (
    <>
    <Helmet>
  <title>Drone Courses & STEM Programs – PracVerse</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="Browse drone education courses by PracVerse – from school and college programs to NGO and corporate CSR workshops, covering building, flying, AI and coding."
  />
  <link rel="canonical" href="https://www.pracverse.com/courses" />

  <meta property="og:title" content="Drone Courses & STEM Programs – PracVerse" />
  <meta
    property="og:description"
    content="Year-long programs, workshops and short-term drone courses for schools, colleges, NGOs and corporates."
  />
  <meta property="og:url" content="https://www.pracverse.com/courses" />
  <meta property="og:image" content="https://www.pracverse.com/images/og-courses.jpg" />

  {/* Course collection schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "Drone Education Courses",
      "url": "https://www.pracverse.com/courses",
      "description":
        "List of drone education courses and STEM programs by PracVerse for schools, colleges, NGOs and corporates.",
      "about": [
        "drone courses",
        "STEM learning",
        "drone education for kids",
        "vocational drone training"
      ]
    })}
  </script>
</Helmet>




    <div className="courses-page">
      {/* HERO */}
      <section className="courses-hero-section">
        <div className="container courses-hero-inner">
          <h1 className="courses-hero-title">Drone Education Courses</h1>
          <p className="courses-hero-sub">
            Comprehensive programs designed to teach students the fundamentals
            of drone technology, from building and programming to advanced AI
            applications and aerial cinematography.
          </p>
        </div>
      </section>

      {/* FILTER PANEL */}
      <section
        className="courses-filter-section"
        aria-labelledby="filter-heading"
      >
        <div className="container">
          <div className="filter-card">
            <div className="filter-head">
              <span className="filter-icon" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M3 5h18M6 12h12M10 19h4"
                    stroke="#1f2340"
                    strokeWidth="1.6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    opacity="0.85"
                  />
                </svg>
              </span>
              <h3 id="filter-heading" className="filter-title">
                Filter Courses
              </h3>
            </div>

            <div
              className="filter-grid"
              role="region"
              aria-label="Course filters"
            >
              {/* Topic filter */}
              {/* <div className="filter-field">
                <label htmlFor="filter-topic">Topic</label>
                <select
                  id="filter-topic"
                  value={topicFilter}
                  onChange={(e) => setTopicFilter(e.target.value)}
                >
                  <option value="">All Topics</option>
                  {uniqueTopics.map((t) => (
                    <option key={t} value={t}>
                      {t}
                    </option>
                  ))}
                </select>
              </div> */}

              {/* Difficulty filter */}
              <div className="filter-field">
                <label htmlFor="filter-level">Category</label>
                <select
                  id="filter-level"
                  value={levelFilter}
                  onChange={(e) => setLevelFilter(e.target.value)}
                >
                  <option value="">All</option>
                  {uniqueLevels.map((lvl) => (
                    <option key={lvl} value={lvl}>
                      {lvl}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* COURSES GRID */}
      <section className="courses-grid-section">
        {/* results count */}
        <div className="container" style={{ maxWidth: 1180 }}>
          <h3 className="results-count">
            {filteredCourses.length} Courses Found
          </h3>
        </div>

        <div className="container courses-grid-container">
          <div className="courses-grid">
            {filteredCourses.map((c) => {
              const difficultyClass = c._difficulty
                ? c._difficulty.toLowerCase()
                : "";

              return (
                <article className="course-card" key={c.id}>
                  <div className="course-media">
                    <img src={c.image} alt={c.title} />
                  </div>

                  <div className="course-body">
                    <div className="course-header-row">
                      <h4 className="course-title">{c.title}</h4>

                      {c._difficulty && (
                        <span
                          className={`level-pill ${difficultyClass}`}
                        >
                          {c._difficulty}
                        </span>
                      )}
                    </div>

                    {/* <p className="course-desc">{c._shortDescription} <a href={`/courses/${c.id}`}>...Read more</a></p> */}
                    <p className="course-desc">
                      {c._shortDescription}{" "}
                      <Link to={`/courses/${c.id}`} onClick={scrollToTopInstant}>
                        ...Read more
                      </Link>
                    </p>
                    

                    <div className="course-stats">
                      {c._duration && (
                        <span className="stat">⏱ {c._duration} hrs</span>
                      )}
                      {c._audience && (
                        <span className="stat">👥 {c._audience}</span>
                      )}
                      {c._topic && (
                        <span className="tag-pill">{c._topic}</span>
                      )}
                    </div>

                    <div className="course-actions">
                      <Link
                        to={`/courses/${c.id}`}
                        className="btn view-details"
                        onClick={scrollToTopInstant}
                      >
                        View Details
                      </Link>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </div>
    </>
  );
}
